import { getDefaultSpySettingByCountry } from '../util/constants'

const preventNonNumericChars = e => {
  if (e) {
    return [('e', 'E', '+', '-')].includes(e.key) && e.preventDefault()
  }
}

const getDefaultCityData = ({ cityData, props, isAdmin }) => ({
  name: cityData ? cityData.name : null,
  pickupInformationURL: cityData ? cityData.pickupInformation : null,
  cbdRadius: cityData ? cityData.cbdRadius : null,
  newcomersMissionsLimit: cityData
    ? cityData.newcomersMissionsLimit
    : props.newcomersMissionsLimit,
  timezone: cityData ? cityData.timezone : null,
  checkinRadius: cityData ? cityData.checkinRadius : null,
  status: cityData ? cityData.statusV2 : props.status,
  payHourly: cityData ? cityData.payHourly : null,
  recruitmentOnHold: cityData ? cityData.recruitmentOnHold : null,
  morningCheckInTime: cityData
    ? cityData.morningCheckInTime
    : props.morningCheckInTime,
  lunchCheckInTime: cityData
    ? cityData.lunchCheckInTime
    : props.lunchCheckInTime,
  afternoonCheckInTime: cityData
    ? cityData.afternoonCheckInTime
    : props.afternoonCheckInTime,
  h2hCheckInTimeBefore: cityData
    ? cityData.h2hCheckInTimeBefore
    : props.h2hCheckInTimeBefore,
  h2hCheckInTimeAfter: cityData
    ? cityData.h2hCheckInTimeAfter
    : props.h2hCheckInTimeAfter,
  d2dCheckInTimeBefore: cityData
    ? cityData.d2dCheckInTimeBefore
    : props.d2dCheckInTimeBefore,
  d2dCheckInTimeAfter: cityData
    ? cityData.d2dCheckInTimeAfter
    : props.d2dCheckInTimeAfter,
  h2hBonusCheckInTimeBefore: cityData
    ? cityData.h2hBonusCheckInTimeBefore
    : props.h2hBonusCheckInTimeBefore,
  h2hBonusCheckInTimeAfter: cityData
    ? cityData.h2hBonusCheckInTimeAfter
    : props.h2hBonusCheckInTimeAfter,
  d2dBonusCheckInTimeBefore: cityData
    ? cityData.d2dBonusCheckInTimeBefore
    : props.d2dBonusCheckInTimeBefore,
  d2dBonusCheckInTimeAfter: cityData
    ? cityData.d2dBonusCheckInTimeAfter
    : props.d2dBonusCheckInTimeAfter,
  countryId: cityData ? cityData.countryId : null,
  teamLeaderEnabled: cityData && isAdmin ? cityData.teamLeaderEnabled : null,
  cityLocation: cityData ? cityData.location : null,
  recruitmentCalendarId: cityData ? cityData.recruitmentCalendarId : null,
  eventsCalendarId: cityData ? cityData.eventsCalendarId : null,
  onboardingLocation: cityData ? cityData.onboardingLocation : null,
  onboardingUrl: cityData ? cityData.onboardingUrl : null,
  isBaDocumentManagementEnabled: cityData
    ? cityData.isBaDocumentManagementEnabled
    : null,
  isOnsiteTrainingEnabled: cityData ? cityData.isOnsiteTrainingEnabled : null,
})

const getDefaultSpyData = ({ cityData }) => {
  const spySettings = cityData && cityData.spySettings
  const defaultSettings = getDefaultSpySettingByCountry(
    cityData && cityData.country && cityData.country.code,
  )

  return {
    hourlyRate: spySettings
      ? spySettings.hourlyRate.toString()
      : defaultSettings.hourlyRate,
    maxBudgetPerWeek: spySettings
      ? spySettings.maxBudgetPerWeek === null
        ? null
        : spySettings.maxBudgetPerWeek.toString()
      : defaultSettings.maxBudgetPerWeek,
    travelAllowancePerMission: spySettings
      ? spySettings.travelAllowancePerMission.toString()
      : defaultSettings.travelAllowancePerMission,
    travelAllowanceCap: spySettings
      ? spySettings.travelAllowanceCap === null
        ? null
        : spySettings.travelAllowanceCap.toString()
      : defaultSettings.travelAllowanceCap,
    durationHandToHandMission: spySettings
      ? spySettings.durationHandToHandMission.toString()
      : defaultSettings.durationHandToHandMission,
    durationLetterboxMission: spySettings
      ? spySettings.durationLetterboxMission.toString()
      : defaultSettings.durationLetterboxMission,
    durationShift: spySettings
      ? spySettings.durationShift.toString()
      : defaultSettings.durationShift,
    missionsPerShift: spySettings
      ? spySettings.missionsPerShift.toString()
      : defaultSettings.missionsPerShift,
  }
}

const getDefaultBaCitySettingsData = ({ cityData }) => {
  const baSettings = cityData && cityData.baSettings
  return {
    baWeeklyMissionsLimit: baSettings ? baSettings.baWeeklyMissionsLimit : null,
    tlaWeeklyMissionsLimit: baSettings
      ? baSettings.tlaWeeklyMissionsLimit
      : null,
  }
}

export {
  preventNonNumericChars,
  getDefaultCityData,
  getDefaultSpyData,
  getDefaultBaCitySettingsData,
}
